import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Container, DeliveryContainer } from './filter-delivery.styles';
import Chip from '../../atoms/Chip';

const FilterDelivery = ({
  filters,
  onChange,
  hasBorder,
  scrollOff
}) => {
  const renderIcon = slug => {
    const Icons = {
      '24c': 'DeliveryRTomorrow',
      delivery_plus_1: 'FastDelivery',
      store_pickup: 'PickupStore',
      delivery_1h: 'Delivery1h',
      delivery_24h: 'Delivery24h',
      'magalu-entregas': 'DeliveryM',
      'magalu-partner': 'Pin',
      free_shipping: 'DeliveryFree',
      today: 'ExpressDelivery',
      magalu_indica: 'FastDelivery',
      promocao_sazonal_1: 'Christmas',
      promocao_sazonal_2: 'CupomPromotion',
      promocao_sazonal_3: 'Offers',
      promocao_sazonal_4: 'Offers'
    };
    return /*#__PURE__*/React.createElement(Icon, {
      name: Icons[slug] || 'FastDelivery'
    });
  };

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "delivery-filter-container",
    carousel: (filters == null ? void 0 : filters.length) > 2,
    scrollOff: scrollOff
  }, /*#__PURE__*/React.createElement(DeliveryContainer, null, filters == null ? void 0 : filters.map(({
    label,
    slug,
    selected,
    href
  }) => /*#__PURE__*/React.createElement(Chip, {
    as: "a",
    type: "checkbox",
    name: "DeliveryFilter",
    startIcon: renderIcon(slug),
    onChange: item => onChange(Object.assign({}, item, {
      href,
      label,
      slug
    })),
    checked: selected,
    href: href,
    value: slug,
    key: slug,
    id: slug,
    hasBorder: hasBorder,
    textMaxWidth: '100%',
    minWidth: '135px',
    maxWidth: '150px',
    padding: '4px',
    gridGap: '6px'
  }, label))));
};

process.env.NODE_ENV !== "production" ? FilterDelivery.propTypes = {
  filters: arrayOf(shape({
    slug: string,
    label: string,
    href: string,
    selected: bool
  })),
  onChange: func,
  scrollOff: bool,
  hasBorder: bool
} : void 0;
FilterDelivery.defaultProps = {
  filters: [],
  onChange: () => {},
  scrollOff: false,
  hasBorder: false
};
export default FilterDelivery;